import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useQuery } from 'react-query';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Messages from './pages/Messages';
import Rules from './pages/Rules';
import { apiService } from './services/api';
import { getEnvironmentInfo } from './config/api';
import './App.css';

// Health check hook
const useHealthCheck = () => {
  return useQuery('health', apiService.health, {
    refetchInterval: 30000, // Check every 30 seconds
    retry: 3,
    refetchOnWindowFocus: false,
  });
};

function App() {
  const {isLoading: healthLoading } = useHealthCheck();
  const envInfo = getEnvironmentInfo();

  return (
    <Router>
      <div className="app">
        <Sidebar />
        <main className="main-content">
          <div className="content-wrapper">
            {healthLoading ? (
              <div className="loading-container">
                <div className="loading-spinner"></div>
                <p>Connecting to AGTI Compliance System...</p>
                <small style={{ color: '#666', marginTop: '10px' }}>
                  Environment: {envInfo.environment} | API: {envInfo.apiBaseUrl}
                </small>
              </div>
            ) : (
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/messages" element={<Messages />} />
                <Route path="/rules" element={<Rules />} />
              </Routes>
            )}
          </div>
        </main>
        {/* Environment indicator */}
        <div style={{
          position: 'fixed',
          bottom: '10px',
          right: '10px',
          background: envInfo.isProduction ? '#22c55e' : '#f59e0b',
          color: 'white',
          padding: '4px 8px',
          borderRadius: '4px',
          fontSize: '12px',
          fontWeight: 'bold',
          zIndex: 1000,
        }}>
          {envInfo.environment.toUpperCase()}
        </div>
      </div>
    </Router>
  );
}

export default App; 